import { Button, message, Modal } from 'antd/lib';
import { useSecureApi } from '../../../hooks/api';
import { url } from '../../../constants/api';

export const RedeployAllWebsite = () => {
  const { callApi, loading } = useSecureApi();
  const onClick = async function () {
    Modal.confirm({
      title: 'Are you sure you want to redeploy all websites?',
      okText: 'Redeploy',
      loading: loading,
      onOk: async () => {
        try {
          await callApi(url('websites/redeploy-all'), {
            method: 'POST',
          });
          message.success('Website redeployment initiated');
        } catch (error) {
          console.error(error);
          message.error('Unable to redeploy websites, Please try again');
        }
      },
    });
  };
  return <Button onClick={onClick}>Redeploy all websites</Button>;
};
